import { render, staticRenderFns } from "./detialsFoot.vue?vue&type=template&id=517a24fd&scoped=true&"
import script from "./detialsFoot.vue?vue&type=script&lang=js&"
export * from "./detialsFoot.vue?vue&type=script&lang=js&"
import style0 from "./detialsFoot.vue?vue&type=style&index=0&id=517a24fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a24fd",
  null
  
)

export default component.exports